import BigNumber from 'bignumber.js'
import store from '_src/store'

import { multiply } from '_src/utils/math'

import { getPolygonGasPrice } from '_src/servers/v2/common'

export const INFINITENUMBER = new BigNumber('f'.repeat(64), 16).toFixed()
export const NATIVEADDRESS = `0x${'0'.repeat(40)}`

/**
 * @description: 获取本地的abi文件
 * @param {type}  ,mystery, work sale
 * @param {version} 版本号 25, 26, 27
 * @param {chainId} 链id 16 进制
 * @param {contractAddress} 接口请求需要传, 默认是取本地的 abi 文件
 * @return {{address,abi}}
 */
export function GetContractAddressAbi({
  type,
  version,
  chainId,
  contractAddress = '', // 接口请求需要传
}) {
  let address = ''
  if (contractAddress) {
    address = contractAddress // 配置的合约
  } else {
    const contractConfig = require('../config/contractConfig.json') // 本地定义的合约
    const contractObject = contractConfig[process.env.REACT_APP_ENV] // 区分环境
    const contractConfigList = contractObject[type]

    const item = contractConfigList.find((item) => item.version === version)
    if (item) {
      address = item[chainId]
    } else {
      address = ''
    }
  }

  return {
    address,
    abi: require(`./abis/${type}/${version}/abi.json`),
  }
}

// 合约对象  使用钱必须登录钱包
/**
 * @description: 创建合约对象
 * @param {config}  配置参数
 * @return {Promise<T>}
 */
export function InftContract(config) {
  // config: {
  //   type,
  //   version,
  //   contractAddress,
  // }

  // web3 chainId 都要从 store 统一入口 中取
  const { global, wallet } = store.getState()
  const { chainId = '' } = global
  const { web3 = '' } = wallet

  return new Promise((resolve, reject) => {
    if (web3 && chainId) {
      const { abi, address } = GetContractAddressAbi({ ...config, chainId })
      try {
        if (abi && address) {
          const contract = new web3.eth.Contract(abi, address) // abi 文件, address: 配置的地址
          resolve(contract)
        } else {
          reject(new Error('Contract not supported the chainId:' + chainId))
        }
      } catch (error) {
        console.log(error)
        reject(error)
      }
    } else {
      reject(new Error('Contract creation failed'))
    }
  })
}

/**
 * @description: 判断是不是主币
 * @param {Object} contract_address 是根据合约地址进行判断
 * @return {Object}
 */
export function isMainCurrency(contract_address) {
  const flag = new BigNumber(contract_address).eq(new BigNumber(`0x${'0'.repeat(40)}`))
  return flag
}

export async function getGasPrice() {
  try {
    const res = await getPolygonGasPrice({
      isNoNeedToken: true,
    })

    if (res && res?.status == 200) {
      const { data: { fast } = {} } = res || {}
      return new Promise((resolve) => {
        resolve(fast?.maxFee ? Math.ceil(multiply(fast?.maxFee, Math.pow(10, 9))) : '')
      })
    } else {
      return new Promise((resolve) => {
        resolve('')
      })
    }
  } catch (error) {
    return new Promise((resolve) => {
      resolve('')
    })
  }
}

/**
 * @description: erc20合约对象
 * @return {Object}
 */
export const CreateErc20Contract = async (contractAddress) => {
  const config = { type: 'common', version: 'erc20', contractAddress }
  const contract = await InftContract(config)
  return contract
}

/**
 * @description: 读取erc20合约精度
 * @param {String} contractAddress erc20合约地址，后台传入
 * @return {Object}
 */
export const readPrecisionFromContract = async (contractAddress) => {
  const Erc20Contract = await CreateErc20Contract(contractAddress)

  const decimals = await Erc20Contract.methods.decimals().call()
  return new Promise((resolve) => {
    resolve(decimals)
  })
}

// const hashOrder = web3.utils.keccak256(
//   web3.eth.abi.encodeParameters(
//     ['address', 'address', 'uint256', 'uint64', 'uint64', 'address', 'uint256', 'address', 'uint256', 'uint256'],
//     [...delParams]
//   )
// )

/**
 * @description: 1.判断余额是否充足
 * @param {String} address
 * @param {Object} InftWorksInfo
 * @param {Object} web3
 * @return {Promise}
 */
export const contractCanBuy = async (web3, address, priceInfo) => {
  const {
    original_price, // 当前售价
    symbol_contract, // 用来区分不同的币种来调不同的合约
  } = priceInfo
  // 获取余额操作进行校验
  let isBuy = true
  if (isMainCurrency(symbol_contract)) {
    // 主币
    const balance = await web3.eth.getBalance(address)

    if (new BigNumber(original_price).gt(new BigNumber(String(balance)))) {
      isBuy = false
    }
  } else {
    // 非主币
    const Erc20Contract = await CreateErc20Contract(symbol_contract)
    const balance = await Erc20Contract.methods.balanceOf(address).call()

    if (new BigNumber(original_price).gt(new BigNumber(String(balance)))) {
      isBuy = false
    }
  }
  return new Promise((resolve) => {
    resolve({ status: true, isBuy })
  })
}
